import getImageUrl from '../../../../modules/getImageUrl';
import type { Tab } from '../../../../types/Tab';

const FALLBACK_TAB_IMAGES: Partial<Record<string, string>> = {
  switch: 'misc/switch.png',
  'switch-2': 'misc/switch.png',
  'nintendo-switch-2': 'misc/switch.png',
  xbox: 'misc/xbox.png',
  'xbox-360': 'misc/xbox.png',
};

export const getTabImages = (tab: Tab): Pick<Tab, 'image' | 'mobileImage'> => {
  const fallback = FALLBACK_TAB_IMAGES[tab.value];
  if (tab.image || tab.mobileImage || fallback === undefined) {
    return { image: tab.image, mobileImage: tab.mobileImage };
  }
  const image = getImageUrl(fallback);
  return { image, mobileImage: image };
};
